import { useContext } from 'preact/hooks'

import { Recovery } from './index'
import StepSwitcher from './StepSwitcher'
import PhoneStep from './Steps/PhoneStep'
import EmailStep from './Steps/EmailStep'
import ConfirmStep from './Steps/ConfirmStep'
import PasswordStep from './Steps/PasswordStep'

import styles from './StepHandler.module.css'
import ErrorMessage from '../ErrorMessage'

const PHONE_STEPS = [<PhoneStep />, <ConfirmStep />, <PasswordStep />]

const EMAIL_STEPS = [<EmailStep />, <ConfirmStep />, <PasswordStep />]

const StepHandler = () => {
  const { step, type, error } = useContext(Recovery)

  const StepCmp = type === 'phone' ? PHONE_STEPS[step] : EMAIL_STEPS[step]

  return (
    <div className={styles.steps}>
      {error && <ErrorMessage text={error} />}
      <StepSwitcher />
      {StepCmp}
    </div>
  )
}

export default StepHandler
